<template>
  <div id="scriptSetting" style="font-family: 'Montserrat';">
    <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
      <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">Script</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon small @click="initScript" color="#3F4360">
        <img
          :src="computeRefreshLogo"
          alt="Refresh"
          class="height-24"
        />
      </v-btn>
    </v-toolbar>
        <v-container>
          <v-card class="script-content" v-for="(item, index) in speechArray" :key="index">
            <v-card-title class="script-content-title" color="#5C82E3">
              {{ item.title }}
            </v-card-title>
            <v-card-text class="script-content-text">
              <div v-html="item.template"></div>
            </v-card-text>
          </v-card>
        </v-container>
    </div>
</template>
<script>
import refreshImg from '@/assets/icons/icon_refresh@3x.png'

export default {
  name: 'script-setting',
  props: {
    loan: Object
  },
  data () {
    return {
      speechArray: []
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    computeRefreshLogo () {
      return refreshImg
    }
  },
  mounted () {
    this.$eventBus.$on('setSpeechCraftTemplate', target => {
      this.speechArray = target
    })
  },
  methods: {
    initScript () {
      this.$eventBus.$emit('getSpeechCraftTemplate')
    }
  }
}
</script>
<style lang="scss" scoped>
.script-content {
  margin: 5px 0 5px 0 !important;
  padding: 0 !important;
  .script-content-title {
    padding: 10px !important;
  }
  .script-content-text {
    padding: 0px 10px !important;
  }
}
.toolbar-card.v-sheet.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: none;
}
</style>
